import React, {Component} from 'react';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import {withTranslation} from "react-i18next";
import {Redirect} from "react-router";

const LoginForm = (props) => {

    return (
        <Formik
            initialValues={{email: '', password: ''}}
            onSubmit={(values, actions) => {

                actions.setStatus({});

                axios.post('/api/user/login', values)
                    .then(
                        data => {
                            actions.setSubmitting(false);

                            if (data.data.success) {
                                actions.setStatus({msg: data.data.message});

                                props.mark_as_logged_in();
                                return (<Redirect push={true} to="/dashboard"/>);
                            }
                        },
                        error => {
                            actions.setSubmitting(false);
                            let response_data = typeof error.response !== 'undefined' ? error.response.data : {errors: []};
                            actions.setErrors(response_data.errors);
                        }
                    )
                    .catch((a, b, c) => {
                        console.log(a, b, c);
                    });
            }}
            render={({errors, status, touched, isSubmitting}) => (
                <div>
                    <Form>
                        <div className="form-group">
                            <label className="form-label" htmlFor="email">{props.t('forms.email')}</label>
                            <Field type="text" name="email" id="email" autoComplete="email"
                                   className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')}/>
                            <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group">
                            <label className="form-label" htmlFor="password">{props.t('forms.password')}</label>
                            <Field type="password" name="password" id="password"
                                   autoComplete={'current-password'}
                                   className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')}/>
                            <ErrorMessage name="password" component="div" className="invalid-feedback"/>
                        </div>

                        <div className="form-group">
                            <button type="submit" className="btn btn-primary btn-block" disabled={isSubmitting}>
                                {props.t('forms.login')}
                            </button>
                        </div>

                        {status && status.msg && <div>{status.msg}</div>}
                    </Form>
                    <p className="small mt-4 text-center">
                        <a href="/auth/forgot_password" target="_self"
                    >{props.t('forms.forgot_password')}</a></p>
                </div>
            )}
        />
    );
};

export default withTranslation()(LoginForm);
